import request from '@/utils/request'
//获取轮播图list
export function upStatus(data) {
  return request({
    url: 'admin/service/status',
    method: 'post',
    data: data,
  })
}
